document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('search-popup');
  const input = document.getElementById('popup-search-input');
  const resultsBox = document.getElementById('popup-search-results');
  const openBtn = document.getElementById('open-search-popup');
  const closeBtn = document.getElementById('close-search-popup');

  // Fallback price formatter
  function formatMoney(cents, format = "${{amount}}") {
    let value = (cents / 100).toFixed(2);
    return format.replace("{{amount}}", value);
  }

  openBtn?.addEventListener('click', () => {
    popup.classList.remove('hidden');
    input.value = '';
    resultsBox.innerHTML = '';
    input.focus();
  });

  closeBtn?.addEventListener('click', () => {
    popup.classList.add('hidden');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      popup.classList.add('hidden');
    }
  });

  let fullResults = [];

  input?.addEventListener('input', function () {
    const query = input.value.trim();
    if (query.length < 2) {
      resultsBox.innerHTML = '';
      fullResults = [];
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
      .then(res => res.json())
      .then(data => {
        const baseProducts = data.resources.results.products || [];

        const fetchDetails = baseProducts.map(p =>
          fetch(`/products/${p.handle}.js`)
            .then(res => res.ok ? res.json() : null)
            .catch(() => null)
        );

        Promise.all(fetchDetails).then(products => {
          fullResults = products.filter(p => p && p.variants?.length > 0);
          if (fullResults.length === 0) {
            resultsBox.innerHTML = `<div class="no-results">No valid products found</div>`;
            return;
          }

          renderResults(fullResults.slice(0, 6), query, true);
        });
      });
  });

  function renderResults(products, query, showAllLink = false) {
    resultsBox.innerHTML = products.map(product => {
      const variants = product.variants || [];
      const defaultVariantId = variants[0]?.id || '';
      const showVariantButtons = variants.length > 1 || (variants.length === 1 && variants[0].title !== 'Default Title');

      const variantButtons = showVariantButtons
        ? variants.map((variant, idx) => `
            <button class="variant-btn${idx === 0 ? ' selected' : ''}" data-variant-id="${variant.id}">
              ${variant.title}
            </button>
          `).join('')
        : '';

      return `
        <div class="popup-search-item">
          <a href="${product.url}">
            <img src="${product.featured_image}" alt="${product.title}" width="60" height="60">
            <div class="popup-product-info">
              <div class="popup-title">${product.title}</div>
              <div class="popup-price">${formatMoney(product.price, "{{amount}}")}</div>
              ${showVariantButtons ? `
                <div class="popup-variants">
                  ${variantButtons}
                  <form class="popup-cart-form" method="post" action="/cart/add">
                    <input type="hidden" name="id" value="${defaultVariantId}">
                    <button type="submit" class="add-to-cart-btn">Add</button>
                    <span class="added-msg" style="display:none;">✔ Added</span>
                  </form>
                </div>
              ` : ''}
    
              
            </div>
          </a>

          
        </div>
      `;
    }).join('');

    if (showAllLink && fullResults.length > 6) {
      resultsBox.innerHTML += `
        <div class="popup-show-all">
          <a href="#" id="show-all-link">Show all (${fullResults.length}) results for '${query}'</a>
        </div>
      `;

      document.getElementById('show-all-link')?.addEventListener('click', function (e) {
        e.preventDefault();
        renderResults(fullResults, query, false);
      });
    }

    attachVariantButtons();
    attachAddToCartForms();
  }

  function attachVariantButtons() {
    document.querySelectorAll('.variant-btn').forEach(button => {
      button.addEventListener('click', function () {
        const variantId = this.dataset.variantId;
        const form = this.closest('.popup-search-item').querySelector('form');
        form.querySelector('input[name="id"]').value = variantId;

        const all = this.parentElement.querySelectorAll('.variant-btn');
        all.forEach(btn => btn.classList.remove('selected'));
        this.classList.add('selected');
      });
    });
  }

  function attachAddToCartForms() {
    document.querySelectorAll('.popup-cart-form').forEach(form => {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const variantId = form.querySelector('input[name="id"]').value;
        const button = form.querySelector('.add-to-cart-btn');
        const msg = form.querySelector('.added-msg');

        button.disabled = true;
        button.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(res => res.json())
        .then(() => {
          button.textContent = 'Add';
          button.disabled = false;
          msg.style.display = 'inline';
          fetchCartAndUpdateCount();
          setTimeout(() => { msg.style.display = 'none'; }, 1000);
        })
        .catch(() => {
          button.textContent = 'Error';
          setTimeout(() => { button.textContent = 'Add'; button.disabled = false; }, 1000);
        });
      });
    });
  }
});